import { DotsHorizontalIcon } from "@radix-ui/react-icons";
import { useRouter } from "@tanstack/react-router";
import { Row } from "@tanstack/react-table";
import { IconTrash, IconEye } from "@tabler/icons-react";
import { useAtom } from "jotai";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { User } from "../data/schema";
import { usersDialogAtom, usersCurrentRowAtom } from "../store/users-atom";

interface DataTableRowActionsProps {
  row: Row<User>;
}

export function DataTableRowActions({
  row,
}: Readonly<DataTableRowActionsProps>) {
  const router = useRouter();
  const [, setOpen] = useAtom(usersDialogAtom);
  const [, setCurrentRow] = useAtom(usersCurrentRowAtom);

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className="data-[state=open]:bg-muted flex h-8 w-8 p-0"
        >
          <DotsHorizontalIcon className="h-4 w-4" />
          <span className="sr-only">Open menu</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[160px]">
        <DropdownMenuItem
          onClick={() => {
            void router.navigate({
              to: "/users/user/$id",
              params: { id: row.original.id },
            });
          }}
        >
          View
          <DropdownMenuShortcut>
            <IconEye size={16} />
          </DropdownMenuShortcut>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={() => {
            setCurrentRow(row.original);
            setOpen("delete");
          }}
          className="!text-red-500"
          disabled={true}
        >
          Delete
          <DropdownMenuShortcut>
            <IconTrash size={16} />
          </DropdownMenuShortcut>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
